import { useState } from "react";
import img from "../assets/images/bus-woman.png";
import { addToNewsletter } from "@services/zenter.service";
const NewsLetter = () => {
  const [email, setEmail] = useState("");

  // const handleSubmit = (e: any) => {
  //   e.preventDafault();
  //   addToNewsletter(email);
  // };

  return (
    <div
      className=" d-flex mt-md-5 align-items-center gap-3 justify-content-evenly px-md-5"
      style={{ maxHeight: "309px" }}
    >
      <div className="d-flex flex-column ">
        <div>
          <h4 className="fs-24 fw-bold font-onest text-white">
            Stay up-to-date on everything Krent
          </h4>
          <p className="fs-12 font-onest text-white text-start">
            Be the first to get the latest updates from krent
          </p>
        </div>
        <div className=" col-10 mt-4">
          <form>
            {/* <form onSubmit={handleSubmit}> */}
            <div className="input-group input-group-flush input-group-merge ">
              <input
                className="form-control list-search border-1 bg-transparent placeholder:text-white"
                type="email"
                name="email"
                value={email}
                onChange={(e: any) => {
                  setEmail(e.target.value);
                }}
                placeholder="Enter email address"
              />

              <button
                type="button"
                className="btn bg-white text-primary fw-600 fs-12 px-4 py-3 "
                style={{ borderRadius: "0 25px 25px 0" }}
                onClick={(e) => {
                  e.preventDefault();
                  addToNewsletter(email);
                  setEmail("");
                }}
              >
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        className="d-none d-md-inline-block"
        style={{ marginTop: "-50px", height: "400px" }}
      >
        <img src={img} alt="" style={{ height: "380px", objectFit: "cover" }} />
      </div>
    </div>
  );
};
export default NewsLetter;
